import { render, staticRenderFns } from "./UiHeading.vue?vue&type=template&id=6751a244"
import script from "./UiHeading.vue?vue&type=script&lang=js"
export * from "./UiHeading.vue?vue&type=script&lang=js"
import style0 from "./UiHeading.vue?vue&type=style&index=0&id=6751a244&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports